<template>
	<router-link
		:aria-label="caption"
		:to="link"
        class="sidebar-link"
	>
		<svg  v-if="icon === 'osce'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" fill="white" class="bi-images b-icon bi">
			<!-- O - top left -->
			<text x="4" y="6.5" font-size="8" font-family="sans-serif" font-weight="bold" text-anchor="middle">O</text>
			
			<!-- S - top right -->
			<text x="12" y="6.5" font-size="8" font-family="sans-serif" font-weight="bold" text-anchor="middle">S</text>
			
			<!-- C - bottom left -->
			<text x="4" y="14.5" font-size="8" font-family="sans-serif" font-weight="bold" text-anchor="middle">C</text>
			
			<!-- E - bottom right -->
			<text x="12" y="14.5" font-size="8" font-family="sans-serif" font-weight="bold" text-anchor="middle">E</text>
		</svg>
		<b-icon v-else :icon="icon"></b-icon>
		<span class="sidebar-hidden-closed">{{caption}}</span>
	</router-link>
</template>

<script>
export default {
	props: {
		caption: String,
		link: String,
		icon: String
	}
};
</script>
<style scoped>
.sidebar-link {
	display: flex;
	align-items: center;
	text-decoration: none;
	color: inherit;
}
</style>